module.exports = __webpack_public_path__ + "img/lowRain.f779908c.svg";